/**
 * Creates a higher-order function that triggers the provided action
 * when a specific key is pressed during a keyboard event.
 *
 * @param {string} - key that triggers the action.
 * @returns {(action: OuterFunction) => (e: KeyboardEvent) => void}
 * A function that takes an action and returns a function handling the keyboard event.
 */
export function onKey(key: string) {
  return (action: OuterFunction) => (e: KeyboardEvent) => {
    if (e.key === key) action(e);
  };
}

export const onEnter = onKey("Enter");

type OuterFunction = (e: KeyboardEvent) => void;
